export default __webpack_public_path__ + "static/media/technology_icon.896ee7e6.svg";